import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import styles from "./index.module.css";
import OrderSummary from "./OrderSummary";
import PaymentSummary, { TermsAndPrivacy } from "./PaymentSummary";
import ProceedButton from "./ProceedButton";
import PayPalCheckout from "./PayPalCheckout";

const CheckoutPage = ({
  // Order data
  order,
  isSelfCheckout,
  selfCheckoutDetails,
  maxExpiryDate,
  // Payment data
  payment,
  registrationDetails,
  subscribedFor,
  subscriptionDuration,
  subscriptionPeriodInterval,
  convenienceFees,
  // Vendor and policy
  vendor,
  policy,
  paypalPlanId,
  refundPolicyPointList,
  businessUnitId,
  isFullpayment,
  xpayLink,
  // Handlers and state
  handleClick,
  setError,
  setSuccess,
  submit,
  setSubmit,
  showClickCheckMark,
  setShowClickCheckMark,
  isPaymentLoading,
  // Utils
  browserInfo,
  ipAddress,
  paymentId,
  addOnDetails,
}) => {
  const currencySymbol = isSelfCheckout
    ? selfCheckoutDetails?.currencySymbol
    : order?.[0]?.currencySymbol;

  return (
    <div className={styles.checkoutPage}>
      <Header businessUnitId={businessUnitId} />
      {/* Body content */}
      <div className={styles.summaryContainer}>
        <OrderSummary
          order={order}
          isSelfCheckout={isSelfCheckout}
          selfCheckoutDetails={selfCheckoutDetails}
          maxExpiryDate={maxExpiryDate}
          addOnDetails={addOnDetails}
          businessUnitId={businessUnitId}
        />
        <div className={styles.divider} />
        <PaymentSummary
          payment={payment}
          registrationDetails={registrationDetails}
          subscribedFor={subscribedFor}
          subscriptionDuration={subscriptionDuration}
          subscriptionPeriodInterval={subscriptionPeriodInterval}
          convenienceFees={convenienceFees}
          currencySymbol={currencySymbol}
          vendor={vendor}
          policy={policy}
          paypalPlanId={paypalPlanId}
          businessUnitId={businessUnitId}
          isFullpayment={isFullpayment}
          xpayLink={xpayLink}
          handleClick={handleClick}
          setError={setError}
          setSuccess={setSuccess}
          submit={submit}
          setSubmit={setSubmit}
          showClickCheckMark={showClickCheckMark}
          setShowClickCheckMark={setShowClickCheckMark}
          order={order}
          isSelfCheckout={isSelfCheckout}
          selfCheckoutDetails={selfCheckoutDetails}
          browserInfo={browserInfo}
          ipAddress={ipAddress}
          paymentId={paymentId}
          isPaymentLoading={isPaymentLoading}
        />
      </div>
      <Footer
        refundPolicyPointList={refundPolicyPointList}
        refundPolicyUrl={policy?.refundPolicy}
        businessUnitId={businessUnitId}
      />

      <div className={styles.proceedButtonContainer}>
        {vendor === "paypal" ? (
          <PayPalCheckout
            plan_id={paypalPlanId || null}
            payment_id={paymentId}
            currency={
              isSelfCheckout
                ? selfCheckoutDetails?.currencyId
                : order?.[0]?.currencyId
            }
            setError={setError}
            setSuccess={setSuccess}
            submit={submit}
            order={order}
            payment={payment}
            browserInfo={browserInfo}
            ipAddress={ipAddress}
            isFullpayment={isFullpayment}
            isSelfCheckout={isSelfCheckout}
            selfCheckoutDetails={selfCheckoutDetails}
          />
        ) : (
          <ProceedButton
            text={`Proceed to Pay ${currencySymbol} ${Number(payment?.amount)?.toFixed(2)}`}
            onClick={handleClick}
            isLoading={isPaymentLoading}
          />
        )}
        <TermsAndPrivacy policy={policy} businessUnitId={businessUnitId} />
      </div>
    </div>
  );
};

export default CheckoutPage;
